export default __webpack_public_path__ + "assets/790e01ba5c3b1966aebc346630037caa.png";